import { acquireAccessToken, getOrCreateAzureAuthInstance } from "@datamole/wds-azure-auth";

import { config } from "@/config";

export const getEntraIdAccessToken = async (): Promise<string | null> => {
    const instance = await getOrCreateAzureAuthInstance();
    return await acquireAccessToken({ scopes: [config.AZURE_AUTH_SCOPE] }, instance);
};

// Token is acquired and cached by the MSAL library, no return value needed.
export const refreshEntraIdSession = async (): Promise<void> => {
    const token = await getEntraIdAccessToken();
    if (!token) {
        throw new Error("Failed to acquire Entra ID access token");
    }
};

/**
 * Clear local auth session.
 * Does NOT clear session on the Microsoft side (that needs a full redirect).
 * */
export const clearEntraIdSession = async (): Promise<void> => {
    try {
        const instance = await getOrCreateAzureAuthInstance();
        await instance.logoutRedirect({
            onRedirectNavigate: () => false, // Prevent navigation, in-place logout
        });
    } catch {
        // Ignore errors during session clearing, as it should not block logout flow
    }
};
